export enum RevisionType {
    CREATION = 'CREATION',
    EDITION = 'EDITION',
    DELETION = 'DELETION'
}
